var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconheadersoundOn = function SvgIconheadersoundOn(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "25px",
    viewBox: "0 0 27 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/SoundOn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/SoundOn",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.5, 3.412)",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.38790518,18.1760979 C5.62767691,15.9344316 7.16882748,12.0900658 7.16882748,8.87040648 C7.16882748,5.42121855 5.60998412,2.29245239 3.07849279,0",
    id: "Path",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.5,15.4748244 C1.50537181,13.7787371 2.54053164,11.4672283 2.54053164,9.08353581 C2.54053164,6.69984331 1.37385263,4.37363036 -0.5,2.78609786",
    id: "Path",
    strokeWidth: 2.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Speaker",
    transform: "translate(1, 0.5)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75,6.54583333 L5.9641946,6.54583333 C6.09170583,6.54583333 6.21439932,6.49711674 6.30718016,6.40964771 L12.1570144,0.894723608 C12.3579436,0.705297912 12.6743887,0.714623292 12.8638144,0.915552426 C12.9512834,1.00833327 13,1.13102675 13,1.25853799 L13,22.741462 C13,23.0176044 12.7761424,23.241462 12.5,23.241462 C12.3724888,23.241462 12.2497953,23.1927454 12.1570144,23.1052764 L6.30718016,17.5903523 C6.21439932,17.5028833 6.09170583,17.4541667 5.9641946,17.4541667 L0.75,17.4541667 C0.473857625,17.4541667 0.25,17.230309 0.25,16.9541667 L0.25,7.04583333 C0.25,6.76969096 0.473857625,6.54583333 0.75,6.54583333 Z",
    id: "Path-20",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconheadersoundOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.header.sound_on.dd632e62a93af58eeb6e0afd10329dfc.svg";